const initialState = ''
// eslint-disable-next-line
export default (state = initialState, action) => {
  switch (action.type) {
    case 'PRODUCTS_FILTER':
      return action.payload
    default:
      return state
  }
};
export const productsFilter = state => state
